// REMOVE WHEN https://github.com/MetaMask/metamask-mobile/issues/29639 closes.
// (BUG-27 mitigation — typed error class for the MM Mobile in-app bridge
// failure. PM monitors Sentry tag `metamask_mobile_bridge_failure:true`;
// when error rate trends to zero, MM has shipped the upstream fix and the
// entire branch — class + detector + useLogin catch + useContractError
// branch — should be deleted in one revert PR.)

/**
 * Thrown by useLogin when MetaMask Mobile's in-app browser bridge fails
 * with `TypeError: connector.getChild is not a function` during
 * signTypedData. The throwing site is inside MetaMask Mobile's own
 * injected provider (NOT in our bundle — see BUG-27 triage).
 *
 * Surfaced to the user via a Persian toast in handleContractError.
 * Reported to Sentry with tag `metamask_mobile_bridge_failure`.
 */
export class MetaMaskMobileBridgeError extends Error {
  readonly code = "METAMASK_MOBILE_BRIDGE_FAILURE" as const;

  constructor(cause: unknown) {
    super("MetaMask Mobile bridge failure (getChild missing)");
    this.name = "MetaMaskMobileBridgeError";
    if (cause instanceof Error) {
      this.cause = cause;
    }
  }
}
